import { AccountInfo } from '../context/account_context'
import { BranchInfo } from '../context/branch_context'
import { CashierInfo } from '../context/cashier_context'
import { DocumentInfo, DocumentTypeInfo } from '../pages/Document/Home'
import { ListReturn } from '../utils/maks'
import { BranchApiData, parseBranch } from './branch'
import { get, post } from './generic'

export interface DocumentTypeApiData {
    id_tipo_documento: number
    nome: string
}

export interface DocumentApiData {
    id_documento: number
    data: string
    hora: string
    id_tipo_documento: number
    id_usuario: number
    usuario: {
        nome: string
    }
    flag_horario_verao: number
    path_documento: string
    estado_documento: number
    tipoDocumento: DocumentTypeApiData
    filial: BranchApiData | null
    id_caixa: number | null
    id_filial: number | null
    caixa: {
        id_caixa: number
        nome: string
    } | null
}

export interface ListDocumentsInterface {
    skip: number
    take: number
    id_tipo_documento: number[]
    id_filial: number[]
    search?: string
    data_inicial?: string
    data_final?: string
    id_usuario?: number[]
}

export interface GenerateGeneralDataInterface {
    data_inicial: string
    data_final: string
}

export function parseDocumentType(data: DocumentTypeApiData): DocumentTypeInfo {
    return {
        id: data.id_tipo_documento,
        name: data.nome,
    }
}

export function parseDocument(data: DocumentApiData): DocumentInfo {
    return {
        id: data.id_documento,
        date: data.data,
        hour: data.hora,
        isSummerTime: Boolean(data.flag_horario_verao),
        documentPath: data.path_documento,
        documentState: data.estado_documento,
        documentType: parseDocumentType(data.tipoDocumento),
        branch: data.filial ? parseBranch(data.filial) : null,
        cashier: {
            id: data.caixa?.id_caixa,
            name: data.caixa?.nome,
        },
        account: {
            name: data.usuario.nome,
        },
    }
}

export async function listDocumentTypes(): Promise<DocumentTypeInfo[]> {
    const res = await get('document-type')
    return res.data.data.map(parseDocumentType)
}

export async function listDocuments(
    data: ListDocumentsInterface
): Promise<ListReturn<DocumentInfo>> {
    const res = await post('documents', data)
    return {
        data: res.data.data.data.map(parseDocument),
        count: res.data.data.count,
    }
}

export async function generateGeneralData(
    data: GenerateGeneralDataInterface
): Promise<void> {
    await post('document/generate-general-data', data, {
        useRecaptcha: true,
    })
}
